<template>
  <div style="position: relative">
    <v-card
      flat
      color="rgb(246 246 246)"
      class="ma-0 rounded-0 d-flex flex-column align-start rounded-b-lg"

    >


      <div v-if="branches"
           class="align-start text-start d-flex flex-column mx-auto"
           style="width: 100%; max-width: 1280px"
           :style="$vuetify.breakpoint.xs ? 'padding: 3.2rem 1rem;' : 'padding: 3.2rem 2.5rem;'"
      >

        <!---- TOP GRADES -->
        <top-grades
        v-if="false"
        style="max-width: 700px; width: 100%" class="mb-4"></top-grades>


        <v-card
          v-if="false"
          class="d-flex flex-column text-center justify-center align-center pa-3 py-10 rounded-lg shadow-sm"
          style="max-width: 700px; width: 100%"
          flat
        >

          <v-btn
            @click="showNewExams=true"
            depressed color="primary"
            class="text-none rounded-pill font-rubik px-12 py-6 mb-8"
            aria-label="Correccions d'avui"
            style="letter-spacing: unset; font-size: 1rem;"
          >
            <v-icon class="mr-3" color="white">{{ mdiCheck }}</v-icon>
            Correccions dels exàmens del {{ year }}
          </v-btn>


          <v-badge content="Dimarts 9, dimecres 10 i dijous 11 de juny"
                   color="primary"
                   class="font-rubik font-weight-medium mx-auto"
                   offset-x="240"
                   offset-y="10"
          >
            <v-chip
              @click="$router.push({path: $route.path, query: {horari: true}})"
              class="font-rubik font-weight-medium pl-6 pr-8 mx-auto"
              large
              outlined
            >
              <v-icon class="mr-3" color="black">{{ mdiCalendar }}</v-icon>
              Veure horari de la Selectivitat {{ year }}
            </v-chip>
          </v-badge>

          <new-exams
            :value.sync="showNewExams"></new-exams>
        </v-card>

        <a :href="aprenAiHome" target="_blank" style="width: 100%;">
        <v-sheet
          elevation="4"
          rounded="lg"
          flat
          class="d-flex flex-column flex-sm-row align-center pa-4 pa-sm-6 text-center text-sm-start mt-5"
          style="max-width: 700px; width: 100%; background: linear-gradient(135deg, #4ED452 0%, #45C049 100%); position: relative; overflow: hidden; border: 2px solid #3cb840; cursor: pointer; transition: all 0.3s ease;"
          :class="$vuetify.breakpoint.xs ? 'pt-12' : ''"
        >
          <!-- Pulsing animation background -->
          <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255,255,255,0.1); animation: pulse 2s infinite;"></div>
          
          <img
            src="https://examenselectivitat.cat:3000/api/images/other/IMG_5242.webp"
            :alt="aprenAiOn ? 'apren.ai, exàmens de selectivitat dinàmics i IA per estudiar, en una tauleta' : 'SeleAI, la IA per estudiar la selectivitat, en una tauleta'"
            fetchpriority="high"
            decoding="async"
            max-height="150"
            max-width="fit-content"
            style="max-width: fit-content; max-height: 200px; object-fit: contain; filter: drop-shadow(0 4px 8px rgba(0,0,0,0.2));"
            contain
            class="rounded-lg"
          >
          
          <div class="d-flex flex-column align-xs-center align-sm-start justify-xs-center mx-3" style="z-index: 2;">
            <v-chip
              color="rgba(255,255,255,0.9)"
              class="font-rubik font-weight-bold mb-2"
              small
              style="color: #333; animation: bounce 2s infinite;"
            >
              🔥 +9.000 estudiants ja l'utilitzen
            </v-chip>
            
            <span
              class="font-rubik font-weight-bold mb-2"
              style="color: #243223; line-height: 1.2; font-size: 1.1rem; text-shadow: 0 2px 4px rgba(0,0,0,0.3);"
            >
              <template v-if="aprenAiOn">Practica la selectivitat al mòbil amb <span class="font-weight-bold" style="color: #023b02; text-decoration: underline;">apren.ai</span></template>
              <template v-else>Estudia sense perdre el temps amb <span class="font-weight-bold" style="color: #023b02; text-decoration: underline;">SeleAI</span></template>
            </span>
            
            <span
              class="font-rubik font-weight-medium mb-3"
              style="color: rgb(3 59 1); line-height: 1.3; font-size: 1rem;"
            >
              <template v-if="aprenAiOn">📱 <b>Exàmens dinàmics</b>: respon i comprova-ho al moment<br></template>
              🔊 <b>Apunts</b> explicats com una classe particular<br>
              ❓ <b>Qüestionaris</b> personalitzats per practicar<br>
              🃏 <b>Flashcards</b> automàtiques per memoritzar<br>
              🤖 <b>Tutor IA</b> que resol tots els teus dubtes<template v-if="!aprenAiOn"><br>
              📚 I si no tens apunts… també en <b>tenim</b></template>
            </span>
            
            <v-btn
              color="#023b02"
              class="text-none rounded-lg font-rubik px-8 py-5 mt-2 pr-5 d-flex align-center"
              large
              depressed
              style="letter-spacing: unset; font-weight: 600; color: white; box-shadow: 0 4px 12px rgba(0,0,0,0.2); transition: all 0.3s ease;"
            >
            <span class="font-rubik font-weight-medium mr-1" style="color: white; line-height: 1.3; font-size: 0.9rem;">
              Començar Ara
            </span>
            <span class="font-rubik font-weight-medium" style="color: #86e283; line-height: 1.3; font-size: 0.9rem;">
              - És gratuït
            </span>
            <v-icon color="white" size="20" class="ml-2">{{ mdiArrowRight }}</v-icon>
            </v-btn>
            
            <span
            v-if="false"
             class="font-rubik mt-2 font-weight-medium" style="color: #333; font-size: 0.75rem;">
              ⚡ Configuració en menys d'1 minut
            </span>
          </div>

          <v-chip
            style="position: absolute; top: 8px; right: 8px;"
            color="#b5ff8d"
            class="font-rubik font-weight-medium"
            small
          >
            <v-icon left size="14" color="#FF6B6B">mdi-fire</v-icon>
            LA IA PER ESTUDIAR
          </v-chip>
          
          <!-- Urgency badge -->
          <v-chip
          v-if="false"
            style="position: absolute; bottom: 8px; left: 8px;"
            color="rgba(255,107,107,0.9)"
            class="font-rubik font-weight-medium"
            small
            text-color="white"
          >
            ⏰ Selectivitat en {{ getMonthsToSelectivitat() }} mesos
          </v-chip>
        </v-sheet>
        </a>

        <v-sheet
        v-if="false"
        @click="$router.push('/dossiers-selectivitat')"
          elevation="0"
          rounded="lg"
          flat
          class="d-flex flex-column flex-sm-row align-center pa-4 pa-sm-6 text-center text-sm-start mt-5"
          style="max-width: 700px; width: 100%; background: linear-gradient(to right, #E3F2FD, #BBDEFB); position: relative; overflow: hidden; border: 1px solid #95cefc"
          :class="$vuetify.breakpoint.xs ? 'pt-12' : ''"
        >
          <img
            src="https://examenselectivitat.cat:3000/api/images/other/IMG_4611x400.webp"
            alt="Dossiers de selectivitat per temes amb solucions"
            max-height="150"
            max-width="fit-content"
            style="max-width: fit-content; max-height: 150px; object-fit: contain;"
            contain
            class="rounded-lg"
          >
          

          <div class="d-flex flex-column align-xs-center align-sm-start justify-xs-center mx-3" style="z-index: 1;">
            <span
              class="font-rubik font-weight-medium mb-3"
              style="color: #1565C0; line-height: 1.3;"
            >
            <b>Estudia millor i estalvia temps ⏳</b> <br>Amb els dossiers per temes i solucions al costat
            </span>
            <v-btn
              @click="$router.push('/dossiers-selectivitat')"
              color="primary"
              class="text-none rounded-lg font-rubik px-6 py-4 mt-2"
              depressed
              style="letter-spacing: unset; font-weight: 500;"
            >
              <v-icon left>{{ mdiBookOpenPageVariant }}</v-icon>
              Veure els dossiers
            </v-btn>
          </div>

          <v-chip
          style="position: absolute; top: 10px; right: 10px;"
          color="primary" outlined class="font-rubik font-weight-medium mb-3">Enviament 24-72h</v-chip>
        </v-sheet>

        <div
          v-for="(branch, idxB) in branches.m_subjectsBranches"
          :key="idxB + 'assignatures-branch'"
          :class="activeTranslation ? 'subjects-slide' : (activeTranslationReverse ? 'subjects-slide-reverse' : '')"
          style="background-color: transparent !important; width: 100%"
          :style="$vuetify.breakpoint.mdAndUp ? 'max-width: 700px' : 'max-width: 100%'"
          class="mt-10"
        >
          <span class="title font-weight-bold">{{ branch.branch_name }}</span>
          <div class="mt-3 d-flex flex-column">
            <div
              v-for="(subject, n) in branch.subjects"
              :key="`branch.subjects-${n}`"
              style="width: 100%"
            >
              <router-link :to="'/selectivitat/' + subject.subject_name"
                           style="width: 100%"
                           :aria-label="subject.subject_name"
              >
                <div class="mb-3 text-start" style="width: 100%">
                  <v-hover v-slot:default="{ hover }">
                    <v-sheet
                      class="rounded-lg text-start justify-start align-center d-flex pa-3"
                      style="width: 100%; min-width: 100%"
                      flat outlined
                      :style="(hover ? `transform: scale(1.02); ` : 'transform: scale(1); ')"
                    >
                      <v-card
                        width="40" height="40"
                        class="d-flex flex-column justify-center align-center mr-3 rounded-circle"
                        :style="`background: linear-gradient(to bottom,rgba(255,255,255,0.7),rgba(255,255,255,0.7)),${getColor(subject)}; `"
                        flat>
                        <v-icon
                          :color="getColor(subject)"
                          style="filter: brightness(80%);"
                          size="22">
                          {{ $vuetify.icons.values[subject.subject_icon] }}

                        </v-icon>
                      </v-card>
                      <span style="white-space: normal; line-height: 1 !important; color: #434343 !important"
                            class="font-rubik font-weight-medium blue-grey--text text--darken-4">
                      {{ subject.subject_name }}
                    </span>
                    </v-sheet>
                  </v-hover>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        style="width: 100%;max-width: 1280px "
        class="d-flex flex-column mb-3 mx-auto"
        :style="$vuetify.breakpoint.xs ? 'padding: 3.2rem 1rem;' : 'padding: 3.2rem 2.5rem;'"
      >
        <div
          v-for="deck in 4"
          :key="`deck-${deck}`"
          style="width: 100%; max-width: 700px"
          class="d-flex flex-column mb-3 mt-7"
        >
          <v-skeleton-loader
            type="text"
            class="mt-3 py-2 rounded-lg"
            style="max-width: 100px"
          ></v-skeleton-loader>

          <v-row
            v-for="sk in 4"
            :key="`skeleton-assig-${sk}`"
            no-gutters
            class="d-flex flex-column"
            style="width: 100%; max-width: 700px"
          >
            <v-skeleton-loader
              type="list-item-avatar" class="mt-3 py-2 rounded-lg white"
              style="border: thin solid #E0E0E0 !important;"
            ></v-skeleton-loader>

          </v-row>
        </div>
      </div>

    </v-card>
  </div>

</template>

<script>
import Branches from "../../examens/Branches";
import {mdiCalendar, mdiCheck, mdiBookOpenPageVariant, mdiArrowRight} from "/src/assets/mdi.json";
import NewExams from "./NewExams.vue";
import { aprenAiUrl, APRENAI_ON } from "../../../utils/aprenAi";
import TopGrades from "./TopGrades.vue";

export default {
  name: "AssignaturesSelector",
  components: {NewExams, TopGrades},
  async mounted() {
    this.branches = await Branches.build();
    this.subjectsBranches = this.branches.getSubjectsBranches()
  },
  data() {
    return {
      year: new Date().getFullYear(),
      aprenAiOn: APRENAI_ON,
      aprenAiHome: aprenAiUrl(null, 'portada'),
      mdiCalendar: mdiCalendar,
      showNewExams: false,
      mdiCheck: mdiCheck,
      mdiBookOpenPageVariant: mdiBookOpenPageVariant,
      mdiArrowRight: mdiArrowRight,
      branches: null,
      selectedBranchTop: 0,
      subjectsBranches: null,
      activeTranslation: false,
      activeTranslationReverse: false,
      selectedBranch: 0,
      branchesLeft: this.$refs.branches ? this.$refs['branches'].$el.offsetLeft : 38,
      branchesColors: [
        {
          bg: '#CCF3FF',
          fg: '#256EFF'
        },
        {
          bg: '#FEE2E2',
          fg: '#B91D1C'
        },
        {
          bg: '#FFFAF0',
          fg: '#C05621'
        },
        {
          bg: '#EAFBF4',
          fg: '#1B8F5D'
        },
        {
          bg: '#E8D6FF',
          fg: '#4338CA'
        },
        {
          bg: '#CCF3FF',
          fg: '#006D8F'
        },
      ],
      colors: [
        "#FF8FB1",
        "#256EFF",
        "#FFA201",
        "#2FCA9F",
        "#C47AFF",
        "#40C4FF",
        "#A460ED",
        "#8C9EFF",
        "#2F89FC",
        "#00BFA5",
        "#ffa63c",
      ]
    }
  },
  methods: {
    getColor(subject) {
      return this.colors[subject.subject_id % this.colors.length]
    },
    getMonthsToSelectivitat() {
      const now = new Date();
      const selectivitatDate = new Date(now.getFullYear(), 5, 6); // 6 de junio
      if (selectivitatDate < now) {
        selectivitatDate.setFullYear(now.getFullYear() + 1);
      }
      const diffTime = Math.abs(selectivitatDate - now);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      const diffMonths = Math.ceil(diffDays / 30);
      return diffMonths;
    },
    selectBranch(i) {
      const id = 'branch_' + i;
      this.branchesLeft = this.$refs['branches'].$el.offsetLeft - 20;
      this.selectedBranchTop = this.$refs[id][0].$el.offsetLeft;
      const selectedBranchWidth = this.$refs[id][0].$el.clientWidth;
      this.branchesLeft += (selectedBranchWidth / 2)

      if (this.lastSelectedBranch !== this.selectedBranch) this.lastSelectedBranch = this.selectedBranch
      this.selectedBranch = i
      if (this.lastSelectedBranch < this.selectedBranch) {
        this.activeTranslation = true;
        setTimeout(() => {
          this.activeTranslation = false;
        }, 300)
      } else {
        this.activeTranslationReverse = true;
        setTimeout(() => {
          this.activeTranslationReverse = false;
        }, 300)
      }
    }
  }

}
</script>

<style scoped>

.branch >>> .v-skeleton-loader__image {
  height: 35px !important;
}

.icon-color {
  -webkit-background-clip: text !important;
  background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}

.reveal {
  position: relative;
  transform: translateY(50px);
  opacity: 0;
  transition: 0.5s all ease;
}

.reveal.active {
  transform: translateY(0);
  opacity: 1;
}

.three-dots {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 160px;
  white-space: nowrap;
}


.selector-arrow {
  transition-property: all;
  transition-duration: 250ms;
}

.subjects-slide {
  -webkit-animation: slide-in-right 0.25s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  animation: slide-in-right 0.25s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

.subjects-slide-reverse {
  -webkit-animation: slide-in-left 0.25s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  animation: slide-in-left 0.25s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

/**
 * ----------------------------------------
 * animation slide-in-right
 * ----------------------------------------
 */
@-webkit-keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(60px);
    transform: translateX(60px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(60px);
    transform: translateX(60px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}


/**
 * ----------------------------------------
 * animation slide-in-left
 * ----------------------------------------
 */
@-webkit-keyframes slide-in-left {
  0% {
    -webkit-transform: translateX(-60px);
    transform: translateX(-60px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-in-left {
  0% {
    -webkit-transform: translateX(-60px);
    transform: translateX(-60px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

/**
 * ----------------------------------------
 * animation pulse
 * ----------------------------------------
 */
@keyframes pulse {
  0% {
    opacity: 0.1;
  }
  50% {
    opacity: 0.2;
  }
  100% {
    opacity: 0.1;
  }
}

/**
 * ----------------------------------------
 * animation bounce
 * ----------------------------------------
 */
@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
}

</style>
